import { render, staticRenderFns } from "./VariationInternalVideo.vue?vue&type=template&id=ef200cec&"
import script from "./VariationInternalVideo.vue?vue&type=script&lang=js&"
export * from "./VariationInternalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports